// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"830889c5","159":"830889c5","761":"e15524a8"}[chunkId] + ".chunk.css";
};